import Markdown from "./components/Markdown";
import Footer from "./components/Footer";
const App = () => {
  return (
    <>
      <section className="section">
        <Markdown />
        <Footer />
      </section>
    </>
  );
};

export default App;
